module.exports = __webpack_public_path__ + "img/orange_074.bdeb57ac.png";